import { Circle, CircleDot, Eye, CheckCircle2, XCircle } from 'lucide-react';

/**
 * Task status icon + label, colour-matched. Used everywhere a task is rendered
 * (list, Kanban card, detail sheet, calendar, dashboard activity, etc.) so the
 * status presentation is consistent across the app.
 */
const STATUS_CONFIG = {
  not_started: { Icon: Circle, label: 'Not Started', color: 'text-muted-foreground/50' },
  in_progress: { Icon: CircleDot, label: 'In Progress', color: 'text-blue-400' },
  review: { Icon: Eye, label: 'Review', color: 'text-purple-400' },
  completed: { Icon: CheckCircle2, label: 'Completed', color: 'text-green-500' },
  cancelled: { Icon: XCircle, label: 'Cancelled', color: 'text-muted-foreground/40' },
};

export function TaskStatusIndicator({ status, size = 'md', className = '' }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.not_started;
  const { Icon, label, color } = cfg;
  const sizes =
    size === 'xs'
      ? { icon: 'h-3 w-3', text: 'text-[10px]' }
      : size === 'sm'
      ? { icon: 'h-3.5 w-3.5', text: 'text-[11px]' }
      : { icon: 'h-4 w-4', text: 'text-[12px]' };
  return (
    <span className={`inline-flex items-center gap-1.5 ${color} ${className}`} data-testid={`status-indicator-${status}`}>
      <Icon className={sizes.icon + ' shrink-0'} />
      <span className={sizes.text + ' whitespace-nowrap'}>{label}</span>
    </span>
  );
}

/** Helper exported so callers can pick a colour to match the indicator if they need it elsewhere. */
export const getStatusColor = (status) => (STATUS_CONFIG[status] || STATUS_CONFIG.not_started).color;
